import { render, staticRenderFns } from "./Manuscripts.vue?vue&type=template&id=dcdc415c&"
import script from "./Manuscripts.vue?vue&type=script&lang=js&"
export * from "./Manuscripts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports